export default function rollDice (rollParts) {
  return rollParts.reduce((acc, part) => {
    if (part.type === 'dice') {
      const [ amount, die ] = part.value.split('d')
      for (let i = 0; i < amount; i++) {
        const result = {
          roll: part.value,
          outcome: Math.round((1 + Math.random() * (die - 1))) * (part.subtract ? -1 : 1)
        }
        acc.rolls.push(result)
        acc.outcome += result.outcome
      }
    } else {
      acc.rolls.push({ 
        outcome: part.value,
        display: part.display
      })
      acc.outcome += part.value
    }
    
    return acc
  }, { outcome: 0, rolls: [] })
}
